import React from 'react';
import { FaEnvelope, FaPen, FaUsers, FaEdit, FaBell, FaChartLine, FaDownload, FaCog } from 'react-icons/fa';

const FeaturesSection = () => {
  return (
    <>
      {/* Features Section start */}
      <div className="service-area bg-gray pd-top-100 pd-bottom-100">
        <div className="container">
          <div className="section-title text-center">
            <h6 className="sub-title">FUNCIONALIDADES</h6>
            <h2 className="title">
              Funcionalidades <span>destacadas</span>
            </h2>
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="single-service-inner text-center h-100">
                <div className="thumb mb-3">
                  <FaEnvelope size={36} className="text-primary" />
                </div>
                <div className="details">
                  <h6 className="mb-2">Envío por correo</h6>
                  <p className="small">
                    Con recordatorios automáticos
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="single-service-inner text-center h-100">
                <div className="thumb mb-3">
                  <FaPen size={36} className="text-primary" />
                </div>
                <div className="details">
                  <h6 className="mb-2">Múltiples tipos de firma</h6>
                  <p className="small">
                    Dibujo, iniciales o nombre
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="single-service-inner text-center h-100">
                <div className="thumb mb-3">
                  <FaUsers size={36} className="text-primary" />
                </div>
                <div className="details">
                  <h6 className="mb-2">Múltiples firmantes</h6>
                  <p className="small">
                    Orden secuencial o paralelo
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="single-service-inner text-center h-100">
                <div className="thumb mb-3">
                  <FaEdit size={36} className="text-primary" />
                </div>
                <div className="details">
                  <h6 className="mb-2">Campos personalizados</h6>
                  <p className="small">
                    Texto, fecha, iniciales
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="single-service-inner text-center h-100">
                <div className="thumb mb-3">
                  <FaBell size={36} className="text-primary" />
                </div>
                <div className="details">
                  <h6 className="mb-2">Notificaciones</h6>
                  <p className="small">
                    En cada hito y resumen final
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="single-service-inner text-center h-100">
                <div className="thumb mb-3">
                  <FaChartLine size={36} className="text-primary" />
                </div>
                <div className="details">
                  <h6 className="mb-2">Panel de control</h6>
                  <p className="small">
                    Estado y historial de auditoría
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="single-service-inner text-center h-100">
                <div className="thumb mb-3">
                  <FaDownload size={36} className="text-primary" />
                </div>
                <div className="details">
                  <h6 className="mb-2">Descarga PDF</h6>
                  <p className="small">
                    Con enlace de verificación
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="single-service-inner text-center h-100">
                <div className="thumb mb-3">
                  <FaCog size={36} className="text-primary" />
                </div>
                <div className="details">
                  <h6 className="mb-2">API (próximamente)</h6>
                  <p className="small">
                    Para integrar tus sistemas
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Features Section end */}
    </>
  );
};

export default FeaturesSection;
